import React from 'react';
import {checkEquationAnswer} from './lib/basic-algebra.js';

export default class EquationAnswerEntry extends React.Component {

  constructor(props) {
    super(props);
    this.handleEquationAnswerSubmit = this.handleEquationAnswerSubmit.bind(this);
    this.handleNewEquationButtonClick = this.handleNewEquationButtonClick.bind(this);
  }

  handleEquationAnswerSubmit(event){
    var enteredAnswer = this.refs.equationAnswerInput.value;
    var isEnteredAnswerCorrect = checkEquationAnswer(this.props.currentProblem,
                                                     enteredAnswer);
    this.props.updateEquationAnswerStatus(isEnteredAnswerCorrect);
    event.preventDefault();
  }

  handleNewEquationButtonClick(){
    this.props.createNewEquation();
    this.refs.equationAnswerInput.focus();
  }

  handleAnswerChange() {
    this.props.updateAnswer(this.refs.equationAnswerInput.value);
  }

  render(){
    return (
      <div className="equation-answer">
        <p className="equation-answer__label">y = </p>
        <div className="equation-answer__input">
          <form onSubmit={this.handleEquationAnswerSubmit}>
            <input
              type="text"
              ref="equationAnswerInput"
              onChange={this.handleAnswerChange.bind(this)}
              value={this.props.currentAnswer}
              autoFocus />
          </form>
        </div>
        <div>
          <button
            type="button"
            className="button--cornflower"
            onClick={this.handleNewEquationButtonClick}>New Equation
          </button>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/algebra/equation_answer_entry.js
 **/